module.exports = __webpack_public_path__ + "resources/img/img_text_to_speech2_jp_m.ae2b7e5267bc0360635e1a3c7c426ed5.png";